import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import './contacts.scss';
import { Constants, ImageConstants, AccessRights } from '../../constants/constants';
import { getImageSource } from '../../utility/image-source';
import AddNewContact from './add-new-contact/add-new-contact'
import CWConfirm from '../common/cw-confirmation-modal/cw-confirmation-modal'
import ContactBulkImport from './contact-bulk-import/contact-bulk-import'
import SessionCache from '../routes/session-cache';
import DeleteTeacher from '../teachers/delete-teacher/delete-teacher'

import SchoolApi from '../../apis/school'
import AssignCoordinator from './assign-coordinator/assign-coordinator';
import SchoolUserApi from '../../apis/student';
import { Modal, ModalBody } from 'reactstrap';
import Dropdown from '../common/dropdown-v2/dropdown';
import InviteTeachers from '../teachers/invite-teachers-v2/invite-teachers-v2';
import ToasterComponent from '../common/cw-toaster-component/cw-toaster-component';
const REJECT_REASONS = [
    { title: "Not School Users", value: "NOT_SCHOOL_USER" },
    { title: "Already Exists", value: "ALREADY_EXISTS" }
]
class Contacts extends Component {

    state = {
        adminUsers: []
    }

    accessRights = SessionCache.getAllowedModule()
    user = SessionCache.getUser()

    componentDidMount() {
        let userInfo = SessionCache.getUser()
        this.setState({ userInfo })
        this.state.staffType = this.props.type
        this.getStaffs()
    }

    getStaffs(payload = {}) {
        const { staffType } = this.state
        payload.types = "in/MATH_HOD,PRINCIPAL,VICE_PRINCIPAL"
        if (staffType === "COORDINATOR") payload.types = "in/COORDINATOR"
        SchoolApi.getStaffs(payload)
            .then(response => {
                this.setState({ adminUsers: response?.response || [] })
            }).catch(err => {
            })

    }

    showAddContactModal = (item, type) => {
        this.setState({ showAddContactModal: true, selectedUser: item, mode: type, showAssignCoordinatorModal: false })
    }

    hideAddContactModal = () => {
        this.setState({ showAddContactModal: false })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    showAssignCoordinatorModal = (item, type) => {
        this.setState({ showAssignCoordinatorModal: true })
    }

    hideAssignCoordinatorModal = () => {
        this.setState({ showAssignCoordinatorModal: false }, _ => {
            this.getStaffs()
        })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    showConfirmModal = (item) => {

        if (!item.classes || !item.classes?.length) {
            let deleteMessage = `Are you sure want to remove ${item.firstName} from this school`
            this.setState({ selectedUser: item, showConfirmModal: true, deleteMessage })
        } else {
            this.setState({ selectedUser: item, showDeleteModal: true })
        }

    }

    showAcceptConfirmModal = (item) => {
        let message = `Are you sure, you want to approve ${item.firstName} from this school?`
        this.setState({ selectedUser: item, showAcceptConfirmModal: true, acceptMessage: message })
    }

    showRejectConfirmModal = (item) => {
        let message = `Are you sure, you want to reject ${item.firstName} from this school?`
        this.setState({ selectedUser: item, showRejectConfirmModal: true, rejectMessage: message })
    }

    hideConfirmModal = () => {
        this.setState({ showConfirmModal: false, emailSendConfirmModal: false, showDeleteModal: false, showAcceptConfirmModal: false, showRejectConfirmModal: false })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    removeUser = (isRejected) => {
        let payload = { _id: this.state.selectedUser?._id }
        if (isRejected) {
            payload.status = { type: "REJECTED", displayType: "Rejected" }
            payload.rejectReason = this.state.rejectReason
            payload.rejectDetails = this.state.rejectDetails
        }
        SchoolApi.deleteStaff(payload)
            .then(response => {
                this.getStaffs()
                this.hideConfirmModal()
            }).catch(err => {
                console.log(err)
            })
    }

    approveSchoolUser = () => {
        let payload = { _id: this.state.selectedUser?._id }
        SchoolUserApi.approveUser(payload)
            .then(response => {
                this.getStaffs()
                this.hideConfirmModal()
            }).catch(err => {
                console.log(err)
            })
    }

    onSelect = (option, key) => {
        this.setState({ [key]: option }, _ => {
            this.validatePayload()
        })
    }

    onChangeHandler = (event, key) => {
        this.setState({ [key]: event.target.value }, _ => {
            this.validatePayload()
        })
    }

    validatePayload = _ => {
        this.setState({
            isValidForm: false
        })
        if (!this.state.rejectReason) return false
        if (!this.state.rejectDetails) return false
        this.setState({
            isValidForm: true
        })
        return true
    }

    onRejectSubmit = _ => {
        this.setState({ showError: true })
        let isValid = this.validatePayload()
        if (!isValid) return
        this.setState({ isSubmit: true })
        this.removeUser(true)
    }

    renderRejectPopup() {
        const { rejectReason, rejectDetails, isValidForm, isSubmit, showError } = this.state
        return (
            <Modal className="cw-custom-modal reject-modal" isOpen={true} toggle={this.hideConfirmModal} size={"lg"}>
                <ModalBody>
                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideConfirmModal} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="reject-modal-body">
                        <div className="title">Reject Reason </div>
                        <div className='row'>
                            <div className='col'>
                                <Dropdown
                                    text='value'
                                    placeholder='Select Reject Reason'
                                    options={REJECT_REASONS}
                                    invalid={showError && !rejectReason}
                                    onSelect={option =>
                                        this.onSelect(option, 'rejectReason')
                                    }
                                    value={rejectReason}
                                    style={{ background: '#F6F7F5' }}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <textarea className="message-input" placeholder='Enter any other details'
                                    value={rejectDetails}
                                    onChange={(e) => this.onChangeHandler(e, 'rejectDetails')} />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col text-center mt-4'>
                                <button className={`cw-button-primary ${(!isValidForm || isSubmit) ? "disable-button" : ""}`} onClick={this.onRejectSubmit}>
                                    REJECT
                                </button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    onSave = () => {
        this.hideAddContactModal()
        this.getStaffs()
    }

    showExcelFormat = () => {
        const link = document.createElement('a');
        link.href = 'https://docs.google.com/spreadsheets/d/1dOCC7kf0QJoD8VRlccvg6NguHtl8S1Hd5gka9G8h-K4/edit?usp=sharing';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }


    bulkImport = () => {
        this.setState({ showBulkImportModal: true })
    }

    hideImport = (refetch) => {
        if (refetch) {
            this.getStaffs()
        }
        this.setState({ showBulkImportModal: false })
    }

    sendEmail = () => {
        let payload = {
            userId: this.state.inviteUser?._id
        }
        SchoolApi.sendInvite(payload)
            .then(response => {
                this.getStaffs()
                this.hideConfirmModal()
            }).catch(err => {
                console.log(err)
            })
    }

    onClickEmail = (item) => {
        this.setState({ emailSendConfirmModal: true, deleteMessage: "Are you sure want send invitation", inviteUser: item })

    }

    onDeleteSuccess = () => {

        this.getStaffs()

        this.hideConfirmModal();
    }

    renderType(item) {
        let types = item?.types.map(type => {
            let contactType = type?.type.split('_').join(' ')
            return contactType
        })
        if (types.length) {
            return types.join(", ")
        }
        return "-----"
    }

    showInviteTeachers = () => {
        this.setState({ showInviteTeachers: true, showAddContactModal: false })
    }

    hideInviteTeachers = (success) => {
        if (success === true) this.showToaster('info', 'Message shared successfully on Whatsapp')
        this.setState({ showInviteTeachers: false })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    showToaster(type, message) {
        this.setState(
            {
                showToaster: true,
                toasterMessage: message,
                toasterType: type
            },
            () => {
                setTimeout(() => {
                    this.hideToaster()
                }, 3000)
            }
        )
    }

    hideToaster() {
        this.setState({
            showToaster: false
        })
    }

    render() {
        const { staffType } = this.state
        return (
            <div className='contacts'>

                <div>

                    <div className='row'>

                        <div className='col text-right'>

                            <div className='row' onMouseEnter={ReactTooltip.rebuild}>
                                <div className='col'>
                                    {
                                        staffType === "COORDINATOR" && this.accessRights[AccessRights.ADD_CONTACT] ? <span >
                                            <button className='cw-btn-md d-inline-block cw-btn-primary mr-2' onClick={() => this.showAssignCoordinatorModal({}, 'CREATE')} data-tip={"Assign Coordinator"}>
                                                ASSIGN COORDINATOR
                                            </button>
                                        </span> : ""
                                    }
                                    {staffType !== "COORDINATOR" && this.accessRights[AccessRights.ADD_CONTACT] ? <span>
                                        <button className='cw-btn-md-v1 d-inline-block cw-btn-secondary mr-2' onClick={() => this.showInviteTeachers()} data-tip={"Invite management via whatsapp<br />through a shared link"}>
                                            INVITE USER VIA WHATSAPP
                                        </button>
                                    </span> : ""}
                                    {
                                        staffType !== "COORDINATOR" && this.accessRights[AccessRights.ADD_CONTACT] ? <span >
                                            <button className='cw-btn-md d-inline-block cw-btn-primary mr-2' onClick={() => this.showAddContactModal({}, 'CREATE')} data-tip={"Add New User"}>
                                                ADD NEW USER
                                            </button>
                                        </span> : ""
                                    }
                                    {/* {
                                        staffType !== "COORDINATOR" && this.accessRights[AccessRights.BULK_UPLOAD_CONTACT] ?
                                            <span>
                                                <button className='cw-btn-md cw-btn-success ' onClick={() => this.bulkImport()} data-tip={"Bulk Import User"}>
                                                    BULK EXCEL UPLOAD
                                                </button>
                                                <br />
                                                <span className='check-text' onClick={this.showExcelFormat}>
                                                    <img
                                                        className='export-xls'
                                                        src={getImageSource(ImageConstants.XLS_BLUE)}
                                                    />
                                                    Check Format Here
                                                </span>
                                            </span> : ""
                                    } */}
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                {this.state.adminUsers && this.state.adminUsers.length ?
                    <div id="table-scoll" className="table-responsive mt-5">
                        <table className="table cw-table mb-0 align-items-center">
                            <thead>
                                <tr>
                                    <th className='th-left-radius'>Name</th>
                                    <th className=''>Contact Type</th>
                                    <th className=''>Email</th>
                                    <th className=''>Mobile Number</th>
                                    <th className=''>Landline</th>
                                    <th className=''>Status</th>
                                    <th className='th-right-radius'></th>
                                </tr>
                            </thead>
                            <tbody className="bg-white">
                                {
                                    this.state.adminUsers && this.state.adminUsers.length ? this.state.adminUsers?.map((item, index) => (

                                        <tr key={item._id + 1} className={`mt-4 ${item?.status?.type === "TO_BE_APPROVED" ? "to-be-approved" : ""}`} onMouseEnter={ReactTooltip.rebuild}>
                                            <td className='py-5'>
                                                {this.accessRights[AccessRights.EDIT_CONTACT] ?
                                                    <div className='name-text cursor-pointer' onClick={() => this.showAddContactModal(item, "EDIT")}>
                                                        {item.firstName ? `${item.firstName} ${item.lastName || ''}` : ''}
                                                    </div>
                                                    :
                                                    <div>
                                                        {item.firstName ? `${item.firstName} ${item.lastName || ''}` : ''}
                                                    </div>
                                                }
                                                {
                                                    this.accessRights[AccessRights.ADD_CONTACT] && item?.status?.type === "TO_BE_APPROVED" &&
                                                    <div>
                                                        <span onClick={_ => this.showAcceptConfirmModal(item)} className='cursor-pointer'>
                                                            <img
                                                                data-tip={"Accept Management profile"}
                                                                className='approve-icn'
                                                                src={getImageSource(ImageConstants.GREEN_TICK_V1)}
                                                            />
                                                        </span>
                                                        <span onClick={_ => this.showRejectConfirmModal(item)} className='cursor-pointer'>
                                                            <img
                                                                data-tip={"Reject Management profile"}
                                                                className='approve-icn'
                                                                src={getImageSource(ImageConstants.RED_REMOVE)}
                                                            />
                                                        </span>
                                                    </div>
                                                }
                                            </td>
                                            <td className='py-5'>{this.renderType(item)}</td>
                                            <td className='py-5'>{item?.email}</td>
                                            <td className='py-5'>{item.mobileNumber ? `${item?.countryCode} ${item?.mobileNumber}` : "N/A"}</td>
                                            <td className='py-5'>{item?.landline || "N/A"}</td>
                                            <td className='py-5'>{item.status?.typeText || "N/A"}</td>
                                            <td className="text-right py-5">
                                                {item?.status?.typeText == Constants.SCHOOL_STATUS.INVITE_SENT && this.accessRights[AccessRights.INVITE_CONTACT] ?
                                                    <span className="px-2">
                                                        <img className="add-contact cursor-pointer mb-1" onClick={() => this.onClickEmail(item)} src={getImageSource(ImageConstants.ENVELOPE)} data-tip={"Send Invitation"} />
                                                    </span>
                                                    :
                                                    <></>
                                                }
                                                {this.accessRights[AccessRights.EDIT_CONTACT] ? <span className="px-2">
                                                    <img className="add-contact cursor-pointer mb-1" onClick={() => this.showAddContactModal(item, "EDIT")} src={getImageSource(ImageConstants.EDIT)} data-tip={"Edit User"} />
                                                </span> : ""}
                                                {
                                                    this.user.id != item._id && this.accessRights[AccessRights.DELETE_CONTACT] ?
                                                        <span className="px-2">
                                                            <img className="add-contact cursor-pointer" onClick={() => this.showConfirmModal(item)} src={getImageSource(ImageConstants.DELETE_RED)} data-tip={"Delete User"} />
                                                        </span> : ""
                                                }
                                            </td>
                                        </tr>
                                    ))
                                        : <tr className="bg-white pt-4"><td colSpan="11" align='center'>No Records found</td></tr>
                                }
                            </tbody>
                        </table>
                    </div >
                    :

                    <div className='no-record-container'>
                        <div className='text-center'><img className='no-record-image' src={getImageSource(ImageConstants.NO_RECORDS)} /></div>
                        <div className='text-center pt-2'><text >No Contacts added currently!</text></div>
                    </div>

                }
                {this.state.showAddContactModal && <AddNewContact type={staffType} show={this.state.showAddContactModal} selectedUser={this.state.selectedUser} mode={this.state.mode} onSave={this.onSave} onClose={this.hideAddContactModal} size='lg' />}
                {this.state.showDeleteModal && <DeleteTeacher close={this.hideConfirmModal} teacher={this.state.selectedUser} onOk={this.onDeleteSuccess.bind(this)} />}
                {this.state.showConfirmModal && <CWConfirm modal={this.state.showConfirmModal} close={this.hideConfirmModal} message={this.state.deleteMessage} onOk={this.removeUser.bind(this)} />}
                {this.state.showBulkImportModal && <ContactBulkImport mode={this.state.mode} size={'lg'} onClose={this.hideImport} title="ADD MANAGEMENT USERS" />}
                {this.state.emailSendConfirmModal && <CWConfirm modal={this.state.emailSendConfirmModal} close={this.hideConfirmModal} message={this.state.deleteMessage} onOk={this.sendEmail.bind(this)} />}
                {this.state.showAssignCoordinatorModal && <AssignCoordinator showAddcontact={this.showAddContactModal} show={this.state.showAssignCoordinatorModal} onClose={this.hideAssignCoordinatorModal} delegate={this.props} />}
                {this.state.showAcceptConfirmModal && <CWConfirm modal={this.state.showAcceptConfirmModal} close={this.hideConfirmModal} message={this.state.acceptMessage} onOk={_ => this.approveSchoolUser(true)} />}
                {this.state.showRejectConfirmModal && this.renderRejectPopup()}
                {this.state.showInviteTeachers && <InviteTeachers type={"management"} onClose={this.hideInviteTeachers} />}
                {this.state.showToaster ? (
                    <div className='custom-toaster-modal'>
                        <ToasterComponent message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" />
                    </div>
                ) : (
                    ''
                )}
                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </div>

        )
    }

}

export default Contacts;